(() => {
  const menuButton = document.querySelector("[data-menu-toggle]");
  const navigation = document.querySelector("[data-site-navigation]");

  if (menuButton && navigation) {
    menuButton.addEventListener("click", () => {
      const isOpen = menuButton.getAttribute("aria-expanded") === "true";
      menuButton.setAttribute("aria-expanded", String(!isOpen));
      navigation.classList.toggle("is-open", !isOpen);
      menuButton.querySelector(".visually-hidden").textContent = isOpen
        ? "Menu openen"
        : "Menu sluiten";
    });
  }

  document.querySelectorAll("[data-product-detail]").forEach((product) => {
    const thumbs = Array.from(product.querySelectorAll("[data-gallery-thumb]"));
    const frames = Array.from(product.querySelectorAll("[data-media-frame]"));
    const currentIndex = product.querySelector("[data-gallery-current]");

    const showMedia = (id) => {
      const frame = frames.find((item) => item.dataset.mediaId === id);
      if (!frame) return;
      frames.forEach((item) => {
        const active = item === frame;
        item.hidden = !active;
        item.classList.toggle("is-active", active);
      });
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaId === id;
        thumb.classList.toggle("is-active", active);
        thumb.setAttribute("aria-pressed", String(active));
        if (active && currentIndex) currentIndex.textContent = thumb.dataset.galleryIndex;
      });
      frame.querySelector("video")?.pause();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", () => showMedia(thumb.dataset.mediaId));
      thumb.addEventListener("keydown", (event) => {
        if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
        event.preventDefault();
        const direction = event.key === "ArrowRight" ? 1 : -1;
        const next = thumbs[(index + direction + thumbs.length) % thumbs.length];
        next.focus();
        showMedia(next.dataset.mediaId);
      });
    });

    const select = product.querySelector("[data-variant-select]");
    if (select) {
      const form = select.closest("[data-product-form]");
      const price = product.querySelector(".js-product-price");
      const comparePrice = product.querySelector(".js-product-compare-price");
      const addButton = form?.querySelector("[data-add-button]");
      const availability = form?.querySelector("[data-variant-availability]");

      const syncVariant = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        if (price) price.textContent = option.dataset.price || "";
        if (comparePrice) {
          comparePrice.textContent = option.dataset.comparePrice || "";
          comparePrice.hidden = !option.dataset.comparePrice;
        }
        const available = option.dataset.available === "true";
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? "Voeg toe aan winkelmand" : "Niet beschikbaar";
        }
        if (availability) {
          availability.textContent = available ? "" : "Deze uitvoering is momenteel niet beschikbaar.";
        }

        const imageUrl = option.dataset.image;
        if (imageUrl) {
          const matchingThumb = thumbs.find((thumb) => thumb.dataset.mediaUrl === imageUrl);
          if (matchingThumb) {
            showMedia(matchingThumb.dataset.mediaId);
          } else {
            const visibleImage = product.querySelector(".product-media-frame:not([hidden]) img");
            if (visibleImage) {
              visibleImage.src = imageUrl;
              visibleImage.alt = option.dataset.imageAlt || visibleImage.alt;
            }
          }
        }
      };
      select.addEventListener("change", syncVariant);
      syncVariant();
    }

    product.querySelectorAll("[data-quantity-change]").forEach((button) => {
      button.addEventListener("click", () => {
        const input = product.querySelector('input[name="quantity"]');
        if (!input) return;
        const current = Number.parseInt(input.value, 10) || 1;
        const minimum = Number.parseInt(input.min, 10) || 1;
        input.value = String(Math.max(minimum, current + Number(button.dataset.quantityChange)));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });
})();
